module.exports = __webpack_public_path__ + "img/help2.c1d38a49.png";